import React from 'react'
import '@dotlottie/player-component'
import './WalkingPanda.scss'

const WalkingPanda = ({label = 'Loading...', style = {}, className = '', hidden}) => {
  return (
    <div
      className={`ap-walking-panda ${hidden ? 'ap-walking-panda--hidden' : ''} ${className}`}
      style={{margin: 'auto', ...style}}
    >
      <div className="ap-walking-panda__icon">
        <dotlottie-player
          src="/loaders/panda-walking-opt2.lottie"
          autoplay
          loop
          style={{width: 160, height: 160, margin: 'auto'}}
        />
        {label && <div style={{width: 'max-content', margin: 'auto', marginTop: -20}}>{label}</div>}
      </div>
    </div>
  )
}

export default WalkingPanda
